/* === WernerArt Wishlist === */
/* Idempotenter Wrapper — Script kann mehrfach geladen werden ohne SyntaxError.
   Wird per <script> in header.liquid, card-product.liquid, main-product.liquid und
   wishlist.liquid eingebunden; nur die erste Ausführung initialisiert. */
if (typeof window.WA_WISHLIST_INIT === 'undefined') {
  window.WA_WISHLIST_INIT = true;

  const WA_WISHLIST_KEY = 'wa_wishlist';

  function waGetWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WA_WISHLIST_KEY)) || [];
    } catch {
      return [];
    }
  }

  function waIsWishlisted(productId) {
    return waGetWishlist().some(item => item.id === String(productId));
  }

  function waToggleWishlist(productId, productData) {
    let list = waGetWishlist();
    const id = String(productId);
    const idx = list.findIndex(item => item.id === id);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({ id, ...productData });
    }
    localStorage.setItem(WA_WISHLIST_KEY, JSON.stringify(list));
    return idx === -1;
  }

  function waUpdateButtons() {
    document.querySelectorAll('.wa-wishlist-btn').forEach(btn => {
      const active = waIsWishlisted(btn.dataset.productId);
      btn.classList.toggle('wa-wishlist-btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.setAttribute('aria-label', active ? 'Aus Merkliste entfernen' : 'Merken');
      const label = btn.querySelector('.wa-wishlist-btn__label');
      if (label) label.textContent = active ? 'Gemerkt' : 'Merken';
    });

    /* Header-Icon + Zähler aktualisieren */
    const count = waGetWishlist().length;
    const badge = document.getElementById('wa-wishlist-count');
    if (badge) {
      badge.textContent = count > 0 ? `(${count})` : '';
      badge.style.display = count > 0 ? '' : 'none';
    }
    const icon = document.querySelector('#wa-wishlist-icon .wa-header-wishlist__icon');
    if (icon) {
      icon.style.fill = count > 0 ? 'var(--wa-terracotta)' : 'none';
      icon.style.stroke = count > 0 ? 'var(--wa-terracotta)' : 'currentColor';
    }
  }

  /* Wishlist-Seite: Karten rendern */
  function waRenderWishlistPage() {
    const grid = document.getElementById('wa-wishlist-grid');
    const empty = document.getElementById('wa-wishlist-empty');
    if (!grid) return;

    const list = waGetWishlist();

    if (list.length === 0) {
      grid.style.display = 'none';
      empty.style.display = 'flex';
      return;
    }

    empty.style.display = 'none';
    grid.style.display = 'grid';

    grid.innerHTML = list.map(item => `
      <div class="wa-wishlist-card">
        <a href="${item.url}" class="wa-wishlist-card__image-link">
          <div class="wa-wishlist-card__image-wrap">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
        </a>
        <div class="wa-wishlist-card__info">
          <a href="${item.url}" class="wa-wishlist-card__title">${item.title}</a>
          ${item.price ? `<span class="wa-wishlist-card__price">${item.price}</span>` : ''}
          <div class="wa-wishlist-card__actions">
            <a href="${item.url}" class="button button--secondary wa-wishlist-card__btn">Zum Werk</a>
            <button
              class="wa-wishlist-btn wa-wishlist-btn--active wa-wishlist-card__remove"
              data-product-id="${item.id}"
              data-product-title="${item.title}"
              data-product-url="${item.url}"
              data-product-image="${item.image}"
              data-product-price="${item.price || ''}"
              aria-label="Aus Merkliste entfernen"
              aria-pressed="true"
              type="button"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
              </svg>
              Entfernen
            </button>
          </div>
        </div>
      </div>
    `).join('');
  }

  function waInitWishlist() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.wa-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const { productId, productTitle, productUrl, productImage, productPrice } = btn.dataset;
      waToggleWishlist(productId, {
        title: productTitle,
        url: productUrl,
        image: productImage,
        price: productPrice || '',
      });

      /* Wishlist-Seite sofort neu rendern wenn wir drauf sind */
      waRenderWishlistPage();
      waUpdateButtons();

      /* Bounce-Feedback */
      btn.classList.add('wa-wishlist-btn--bounce');
      btn.addEventListener('animationend', () => btn.classList.remove('wa-wishlist-btn--bounce'), { once: true });
    });

    waRenderWishlistPage();
    waUpdateButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waInitWishlist);
  } else {
    waInitWishlist();
  }
}
